import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_MCP_SERVER_URL;

export const socket = io(SOCKET_URL, {
  autoConnect: false, // Don't connect automatically
});

export const socketService = {
  connect: (onConnect = () => {}) => {
    // Only connect if not already connected
    if (socket.connected) {
      console.log('Already connected to socket server');
      onConnect();
      return;
    }

    // Connect if the socket is disconnected
    if (!socket.connected) {
      socket.connect();
    }

    // Remove existing listeners to prevent duplicates
    socket.off('connect');
    socket.off('disconnect');

    socket.on('connect', () => {
      console.log('Connected to socket server');
      onConnect();
    });

    socket.on('disconnect', () => {
      console.log('Disconnected from socket server');
    });
  },

  isConnected: () => {
    return socket.connected;
  },

  sendChatMessage: (text, conversationId = undefined, address = undefined) => {
    const message = {
      id: Date.now().toString(),
      sender: 'user',
      text,
      timestamp: new Date(),
      address,
    };

    console.log({ message, conversationId });
    socket.emit('chat_message', message, conversationId, address);
    return message;
  },

  onChatResponse: callback => {
    // Remove any existing listeners first to prevent duplicates
    socket.off('chat_response');
    socket.on('chat_response', response => {
      callback(response);
    });
  },

  onChatError: callback => {
    // Remove any existing listeners first to prevent duplicates
    socket.off('chat_error');
    socket.on('chat_error', error => {
      callback(error);
    });
  },

  onChatTyping: callback => {
    // Remove any existing listeners first to prevent duplicates
    socket.off('chat_typing');
    socket.on('chat_typing', data => {
      callback(data);
    });
  },

  disconnect: () => {
    // Remove all listeners before disconnecting
    socket.off('connect');
    socket.off('disconnect');
    socket.off('chat_response');
    socket.off('chat_error');
    socket.off('chat_typing');

    socket.disconnect();
  },

  reset: () => {
    // Completely reset the socket state
    socket.off('connect');
    socket.off('disconnect');
    socket.off('chat_response');
    socket.off('chat_error');
    socket.off('chat_typing');

    if (socket.connected) {
      socket.disconnect();
    }

    // Recreate the socket instance
    socket = io(SOCKET_URL, {
      autoConnect: false,
    });
  },
};

export default socketService;
